module.exports = __webpack_public_path__ + "img/texas_dark_grey_ba_list.9d1bed77.jpg";